import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {SpineUtils} from "../../utils/SpineUtils";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2022-12-19.
 */

export class BenjiKIVSFSMoreScatterView extends PIXI.Container implements StageLayer {

    private static ANIMATION_NAME:string = "Plus_2";

    private _background:PIXI.Sprite;
    private _sfsIntroAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BenjiKIVSFSMoreScatterView";
        this.init();
    }

    private init():void {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._sfsIntroAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.PLUS_2_SPINE));
        this._sfsIntroAnimation.position.set(360, 360);
        this._sfsIntroAnimation.visible = false;
        this.addChild(this._sfsIntroAnimation);

        this.onResize();
    }

    public getSFSMoreScatterTL():gsap.core.Timeline {
        const SFSMoreScatterTL:gsap.core.Timeline = gsap.timeline();
        SFSMoreScatterTL.add(() => {
            this._background.alpha = 0;
        });
        SFSMoreScatterTL.add([
            gsap.to(this._background, {duration : 0.4, alpha : 0.7}),
            () => {this._sfsIntroAnimation.visible = true},
            () => {this._sfsIntroAnimation.alpha = 1},
            () => {SpineUtils.resetSpineAnimation(this._sfsIntroAnimation)},
            () => BenjiKIV.soundPlayer.playSound(BenjiKIVSound.SFS_PLUS_2),
            new SpineTween(this._sfsIntroAnimation, 0, BenjiKIVSFSMoreScatterView.ANIMATION_NAME)
        ])
        ;

        SFSMoreScatterTL.add(() => {
            BenjiKIV.keypadPlugin.setZeroBetSpinCounter(BenjiKIV.model.freespinsLeft)
        }, "-=0.1");

        SFSMoreScatterTL.add([
            gsap.to(this._sfsIntroAnimation, {duration : 0.1, alpha : 0}),
            gsap.to(this._background, {duration : 0.2, alpha : 0}),
            () => {BenjiKIV.soundPlayer.stopSound(BenjiKIVSound.SFS_PLUS_2)}
        ]);

        return SFSMoreScatterTL;
    }

    public onResize():void {
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }
}